import { useEffect, useState } from 'react';

export function useLocalStorage(itemName, initialValue) {
  const [item, setItem] = useState(initialValue);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      try {
        const localStorageItem = localStorage.getItem(itemName);
        let parsedItem;

        if(!localStorageItem) {
          localStorage.setItem(itemName, JSON.stringify(initialValue));
        }
        parsedItem = localStorageItem ? JSON.parse(localStorageItem) : initialValue;

        setLoading(false);
        setItem(parsedItem);
      } catch (error) {
        setLoading(false);
        setError(true);
        console.error(error);
      }
    }, 1800);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveItem = (newItem) => {
    localStorage.setItem(itemName, JSON.stringify(newItem));
    setItem(newItem);
  };

  return {item, saveItem, loading, error};
}